import './savingsAccountsOffersViewAccordeon.scss';
// vendors
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
// components
import { Accordion } from 'commonsComponents/accordion';
import { AccordionBody } from 'commonsComponents/accordionBody';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import SavingsAccountsOffersViewTableRow from '../savingsAccountsOffersViewTableRow/savingsAccountsOffersViewTableRow';
// helpers
import { formatAmount, formatCurrency, groupByCurrency } from 'utilities/currencyHelper';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
// constants 
import { SAVINGS_PRODUCT_TYPE } from 'constants/eAccountLoan';

const BASE_CLASSNAME = "savings-accordion";

const SavingsAccountsOffersViewAccordeon = ({ immAccounts }) => {
    const savingsAccounts = useMemo(() =>
        immAccounts.get("byId").filter(account => account.get('newProduct') === SAVINGS_PRODUCT_TYPE).toJS(),
        [immAccounts]
    );

    const balances = useMemo(() => {
        const savingsGroupedByCurrency = groupByCurrency(savingsAccounts);
        const sortedSavingsGroupedByCurrency = savingsGroupedByCurrency.sort((a, b) => {
            if (a.currency === "EUR") return 1;
            if (b.currency === "EUR") return -1;
            return 0;
        });
        const listItems = sortedSavingsGroupedByCurrency.map((balance, index) => {
            const amountFormatted = formatAmount(balance.amount);
            const currencyFormatted = formatCurrency(balance.currency);

            return (
                <li className={`${BASE_CLASSNAME}__header-balance-list-item`} key={index}>
                    {savingsGroupedByCurrency.length > 1 && <div className={`${BASE_CLASSNAME}__header-balance-label`}>{formatText('accounts-balance')} {currencyFormatted}</div>}
                    <span>{amountFormatted}</span>&nbsp;
                    <span>{currencyFormatted}</span>
                </li>
            );
        });
        return (
            <div>
                {savingsGroupedByCurrency.length === 1 && <FormattedText value="myGlobalPosition-balance" />}
                <ul className={`${BASE_CLASSNAME}__header-balance-list`}>
                    {listItems}
                </ul>
            </div>
        )
    }, [immAccounts]);

    const tableRows = useMemo(() =>
        Object.values(savingsAccounts).map((account, index, array) => (
            <SavingsAccountsOffersViewTableRow key={index} account={account} isLast={index === array.length - 1} />
        )),
        [savingsAccounts]
    );

    return (
        <Accordion isExpanded={false} customClassName={BASE_CLASSNAME} >
            <AccordionHeader name="AccordionHeader">
                <div className={`${BASE_CLASSNAME}__header`}>
                    <div className={`${BASE_CLASSNAME}__header-title`}>
                        <FormattedText value="savingsAccounts-savingsAccounts_savingsAccount" /> {`(${Object.keys(savingsAccounts).length})`}
                    </div>
                    <div className={`${BASE_CLASSNAME}__header-balance`}>
                        <div className={`${BASE_CLASSNAME}__header-balance-amount`}>
                            {balances}
                        </div>
                    </div>
                </div>
            </AccordionHeader>
            <AccordionBody name="AccordionBody">
                <div className={`${BASE_CLASSNAME}__body`}>
                    <div className={`${BASE_CLASSNAME}__body-separator`} />
                    <article>
                        <table className={`${BASE_CLASSNAME}__table`}>
                            <thead className={`${BASE_CLASSNAME}__table-header`}>
                                <tr>
                                    <th className={`${BASE_CLASSNAME}__table-column-large`}>{formatText("savingsAccounts-savingsAccounts_accountName")}</th>
                                    <th className={`${BASE_CLASSNAME}__table-column-small`}>{formatText("savingsAccounts-savingsAccounts_intervention")}</th>
                                    <th className={`${BASE_CLASSNAME}__table-column-small`}>{formatText('accounts-balance').toUpperCase()}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableRows}
                            </tbody>
                        </table>
                    </article>
                </div>
            </AccordionBody>
        </Accordion>
    );
};

SavingsAccountsOffersViewAccordeon.propTypes = {
    immAccounts: PropTypes.object.isRequired,
};

export default SavingsAccountsOffersViewAccordeon;
